import React, { useState, useEffect } from 'react';
import * as Utils from '../../common/utils';
import BraftEditor from 'braft-editor';
import * as REQUEST from "../../common/request";
import './index.less';

const PageModel = props => {
    const [url, setUrl] = useState('');
    const [list, setList] = useState([]);
    const [contentDetail, setContentDetail] = useState('');//富文本展示

    const getbanner = async () => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/file/get',
            data: { id: 6 }
        });
        if (!result) return;
        setUrl(result.data.link);
    };

    const getList = async (selectedId) => {
        const result = await REQUEST.get({
            url: '/zhujiajiao/v2/cruise/list',
            data: { type: selectedId }
        });
        if (!result) return;
        setList(result.data);
        setContentDetail(result.data[0].content);
    };
    useEffect(() => {
        getList();
        getbanner();
        Utils.setPageTitle('游船信息');
        return () => false;
    }, [123]);

      const editorState = BraftEditor.createEditorState(contentDetail);
      const contentHtml = editorState.toHTML();


    return (
        <section className="h5cruise-container" style={{ minHeight: window.innerHeight }}>
            <div className='h5cruise-top-img'>
                <img src={'https://static-yeekin.oss-cn-shanghai.aliyuncs.com/' + url} alt="" />
            </div>

            <div className='h5cruisedetail-bottom'>
                <div className='h5cruisedetail-bottom-title' dangerouslySetInnerHTML={{ __html: contentHtml }} ></div>
            </div>

            <div className='h5cruise-bottom-img'>
                <img src={require('./images/bottom.png')} alt="" />
            </div>
        </section>
    );
};

export default PageModel;
